import React from "react";

const grey = "#707070";
const ContentRatings = ({
  color = grey,
  viewBox = "0 0 18 18",
  height = 20,
  width = 20,
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
      height={height}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill={color}
          d="M18 0h-2.842v18H18zM14.21 2.842H11.37V18h2.842zM10.421 8.526H7.579V18h2.842zM6.632 9.474H3.79V18h2.842zM2.842 11.368H0V18h2.842z"
        />
        <path
          fill={color}
          fillRule="nonzero"
          d="M2.973 6.554h.47l.168-.16a3.873 3.873 0 11.417.417l-.161.166v.47l-2.98 2.974L0 9.533l2.973-2.979zm3.575 0A2.678 2.678 0 009.23 3.873a2.678 2.678 0 00-2.68-2.681 2.678 2.678 0 00-2.682 2.68 2.678 2.678 0 002.681 2.682z"
        />
      </g>
    </svg>
  );
};

export default ContentRatings;
